import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "@/messages/action-buttons.messages";

export type LojaIntegradaAccountConnectionMessages = ActionButtonMessages & {
  lojaIntegradaAccountConnectionText1: string;
  errorRequiredApiKey: string;
  apiKeyLabel: string;
  errorLojaIntegradaSubscription: string;
};

export const lojaIntegradaAccountConnectionMessages: LojaIntegradaAccountConnectionMessages = {
  lojaIntegradaAccountConnectionText1:
    "Informe as suas chaves de acesso da Loja Integrada para conectar sua conta.",

  errorRequiredApiKey: "Por favor, informe a sua Api Key",
  apiKeyLabel: "Api Key",
  errorLojaIntegradaSubscription: "Ocorreu um erro ao se inscrever na Loja Integrada",

  ...ACTION_BUTTON_MESSAGES,
};
